





































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Tooltip } from 'element-ui';

// types
import { ChannelTypeEnum } from '@/types/graphql/schemaTypes';
import { MixedChannelTypeEnum } from '@/types/types';

// constants
import { Icons } from '@/constants/channel';

@Component({
  components: {
    'el-tooltip': Tooltip
  }
})
export default class ChannelOverlay extends Vue {
  @Prop({ required: true, type: String }) channelId!: string;
  @Prop({ required: true, type: String }) title!: string;
  @Prop({ default: ChannelTypeEnum.public, type: String }) type!: MixedChannelTypeEnum;
  @Prop({ default: false, type: Boolean }) embeded!: boolean;
  @Prop({ default: false, type: Boolean }) hasUnread!: boolean;
  @Prop({ default: '', type: String }) icon!: string;

  readonly localStorageStatusKey: string = `channel-${this.channelId}-status`;

  // isMinimized is public so we can get the overlay status with overlay.isMinized
  private isMaximized = sessionStorage.getItem(this.localStorageStatusKey) === 'maximized' || false;
  public isMinimized = sessionStorage.getItem(this.localStorageStatusKey) === 'minimized' || false;

  private get iconName(): string {
    let name = this.icon;
    if (!name) { // default icon for types
      name = Icons[this.type];
    }
    return name;
  }

  private get isEditionAvailable(): boolean {
    return this.type === ChannelTypeEnum.partner;
  }

  mounted() {
    this.$root.$on('channelMaximized', this.appendMaximized);
    this.$root.$on('selectChannel', this.openChannel);
  }

  destroyed() {
    this.$root.$off('channelMaximized', this.appendMaximized);
    this.$root.$off('selectChannel', this.openChannel);
  }

  appendMaximized(id: string) {
    if (id !== this.channelId && this.isMaximized) {
      this.isMaximized = false;
      sessionStorage.setItem(this.localStorageStatusKey, 'opened');
    }
  }

  toggleMaximize(id: string) {
    if (sessionStorage.getItem(this.localStorageStatusKey) === 'maximized') {
      sessionStorage.setItem(this.localStorageStatusKey, 'opened');
      this.isMaximized = false;
    } else {
      sessionStorage.setItem(this.localStorageStatusKey, 'maximized');
      this.isMaximized = true;
      this.$root.$emit('channelMaximized', id);
    }
  }

  toggleMinimize(id: string) {
    if (sessionStorage.getItem(this.localStorageStatusKey) !== 'minimized') {
      sessionStorage.setItem(this.localStorageStatusKey, 'minimized');
      this.isMinimized = true;
    } else {
      this.openChannel(id);
    }
  }

  openChannel(id: string) {
    if (this.channelId === id) {
      sessionStorage.setItem(this.localStorageStatusKey, 'opened');
      this.isMinimized = false;
      this.$emit('open');
    }
  }
}
